// @flow
import * as React from 'react';
import styles from './RatingRange.scss';
import range from 'lodash/range';

const MIN_RATING = 1;
const MAX_RATING = 5;
const STEP = 1;

type RangeValue = [number, number];
type Props = {
  value: RangeValue,
  name: string,
  onChange: RangeValue => void,
};

export default class RatingRange extends React.PureComponent<Props, void> {
  static defaultProps = {
    name: 'RatingRange',
    value: [MIN_RATING, MAX_RATING],
  };

  handleStartChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const newStart = Number(e.currentTarget.value);
    const currentEnd = this.props.value[1];
    const newEnd = newStart > currentEnd ? newStart : currentEnd;

    this.props.onChange([newStart, newEnd]);
  };

  handleEndChange = (e: SyntheticEvent<HTMLInputElement>) => {
    const newEnd = Number(e.currentTarget.value);
    const currentStart = this.props.value[0];
    const newStart = currentStart > newEnd ? newEnd : currentStart;

    this.props.onChange([newStart, newEnd]);
  };

  render() {
    const { name, value: [startValue, endValue] } = this.props;
    const startRange = range(
      MIN_RATING,
      Math.min(MAX_RATING, endValue) + STEP,
      STEP
    );
    const endRange = range(startValue, MAX_RATING + STEP, STEP);

    return (
      <div className={styles.ratingRange}>
        <select
          name={`${name}_start`}
          className={styles.ratingRangeInput}
          value={startValue}
          onChange={this.handleStartChange}
        >
          {startRange.map(v => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
        <span className={styles.ratingRangeText}> to </span>
        <select
          name={`${name}_end`}
          className={styles.ratingRangeInput}
          value={endValue}
          onChange={this.handleEndChange}
        >
          {endRange.map(v => (
            <option key={v} value={v}>
              {v}
            </option>
          ))}
        </select>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/search/SearchForm/RatingRange.js